module.exports = __webpack_public_path__ + "img/full0-min.ddcd91e9.png";